/**
 * @file Trail component: emits particles as the entity moves.
 *
 * Distance-based rather than time-based, so the trail spacing stays constant
 * across speed changes.
 */

import { Component } from '../ecs/Component.js';

export class Trail extends Component {
  /**
   * @param {object} options Trail setup.
   * @param {number} options.distance World units between puffs.
   * @param {number} options.color Puff colour.
   * @param {number} options.size Puff radius.
   * @param {number} options.life Puff lifetime in seconds.
   */
  constructor({ distance, color, size, life }) {
    super();
    /** @type {number} */
    this.distance = distance;
    /** @type {number} */
    this.color = color;
    /** @type {number} */
    this.size = size;
    /** @type {number} */
    this.life = life;
    /** @type {number} Distance accumulated since the last puff. */
    this.travelled = 0;
  }

  /** @returns {void} */
  reset() {
    this.travelled = 0;
  }
}
